import styled from "styled-components/macro";

export const DivButtonPrimaryLogoContainer = styled.div`
  padding: 0 var(--g2);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--gold);
`;
